<template>
  <div>
    <el-container>
      <el-header :style="{background: '#206AD7',color:'#fff',height: headerHeight+'px',position: 'relative'}">
        检测管理系统
        <el-button type="primary" :icon="openMenuIcon" @click="openCloseMenu()" style="margin-top: 5px;background: #206AD7;border: 0px "></el-button>
        <el-button type="primary" v-if="bussinessButVisible" @click="meunChange('business')" :style="{background: '#206AD7',border: '0px',color: bussinessWordColor}">业务菜单</el-button>
        <el-button type="primary" v-if="systemButVisible" @click="meunChange('system')" :style="{background: '#206AD7',border: '0px',color: systemWordColor}">系统菜单</el-button>
        <div style="float: right;padding-top: 10px">
          欢迎你，{{this.$store.state.loginUser.userName}}
          <i class="el-icon-s-custom" @click="showMyDialog()" @mouseover="showMyDialog()" @mouseout="closeMyDialog()"></i>
        </div>
        <div class="contextMenu" v-show="isShowContextMenu" @mouseleave="handleMouseLeave()" @mouseover="handleMouseOver()">
          <ul>
            <li><span>{{this.$store.state.loginUser.userName}}</span></li>
            <li @click="updatepwd()">
              <font style="cursor:hand;">修改密码</font>
            </li>
            <li @click="exit()">
              <font style="cursor:hand;">退出</font>
            </li>
          </ul>
        </div>
      </el-header>
      <el-container>
        <el-aside :style="{height: leftmenuHeight+'px',background:'#545c64',overflowX:'hidden'}" :width="menuWidth">
          <el-menu :collapse="isCollaped" :collapse-transition="false" :default-openeds="activiArr" class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff"
                   active-text-color="#ffd04b">
            <!-- <el-submenu index="1">
                             <template slot="title">
                                 <i class="el-icon-menu"></i>
                                 <span>系统管理</span>
                             </template>
                             <el-menu-item-group>
                                 <span slot="title">权限管理</span>
                                 <el-menu-item index="1-1"  @click="addTab('企业管理','views/system/tenant/TenantModule.vue')">
                                     <i class="el-icon-menu"></i>
                                     企业管理
                                 </el-menu-item>
                                 <el-menu-item index="1-2" @click="addTab('用户管理','views/system/user/UserModule.vue')">
                                     <i class="el-icon-menu"></i>
                                     用户管理
                                 </el-menu-item>
                                 <el-menu-item index="1-3" @click="addTab('角色管理','views/system/role/RoleModule.vue')">
                                     <i class="el-icon-menu"></i>
                                     角色管理
                                 </el-menu-item>
                                 <el-menu-item index="1-4" @click="addTab('权限管理','views/system/permission/PermissionModule.vue')">
                                     <i class="el-icon-menu"></i>
                                     权限管理
                                 </el-menu-item>
                             </el-menu-item-group>
                         </el-submenu>-->
            <el-submenu :index="item.moduleName" v-for="item in menuData" :key="item.moduleName">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span>{{item.moduleName}}</span>
              </template>
              <el-menu-item-group style="margin-top: -20px;margin-bottom: -2px">
                <el-menu-item :index="menu.moduleName" @click="addTab(menu.moduleName,menu.url)" v-for="menu in item.children" :key="menu.moduleName + '|' + menu.url">
                  <i class="el-icon-caret-right"></i>
                  {{menu.moduleName}}
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-main style="margin: -18px -15px -15px -18px">
          <el-tabs v-model="editableTabsValue" type="card" @tab-remove="removeTab" @tab-click="handleTabClick">
            <el-tab-pane v-for="item in editableTabs" :closable="item.closable" :key="item.name" :label="item.title" :name="item.name">
              <!--ue动态引入（按需引入）组件并传值:winHeight-->
              <!--
                关键修复：用 url 作为 key，确保同一个 Tab 复用时，只要 url 变化就会销毁并重建组件
                否则 RecordDialog 这类“页面型组件”会残留上一单的状态（且本框架未使用 keep-alive，activated 不会触发）
              -->
              <component :is="item.content" :key="item.name + '|' + (item.url || '')" :clientHeight="clientHeight" :url="item.url"></component>
            </el-tab-pane>
          </el-tabs>
        </el-main>
      </el-container>
    </el-container>
    <!--添加div-->
    <el-dialog title="修改密码" :visible.sync="drawer" :wrapperClosable="false" direction="rtl">
      <UpdateUserPasswordWindow ref="updateUserPasswordWindow" :closeWindow="closeWindow"></UpdateUserPasswordWindow>
    </el-dialog>
  </div>
</template>
<script>
import { appjs } from '@/utiljs/apputil';
import UpdateUserPasswordWindow from '@/views/main/UpdateUserPasswordWindow.vue';
export default {
  components: {
    UpdateUserPasswordWindow
  },
  data () {
    let headerHeight = 45;
    return {
      drawer: false,
      openMenuIcon: 'el-icon-s-fold',
      headerHeight: headerHeight,
      tabIndex: 1,
      editableTabsValue: '1',
      activiArr: [],
      menuData: [],
      systemData: [],
      bussinessData: [],
      systemButVisible: false,
      bussinessButVisible: false,
      systemWordColor: '#fff',
      bussinessWordColor: '#fff',
      isCollaped: false,
      menuWidth: '230px',
      editableTabs: [{
        title: '首　页',
        name: '1',
        closable: false,
        content: () => import('@/views/home/Home.vue')
      }],
      leftmenuHeight: (document.documentElement.clientHeight - headerHeight),
      clientHeight: document.documentElement.clientHeight,
      isShowContextMenu: false,
      isMouseInMenu: false,

      // 记录每个 Tab 最近一次“激活强制重载”的 token，避免同一次激活重复写 url
      _tabReloadToken: {}
    }
  },
  watch: {
    // 切换标签页时，如果进入“原始记录管理”页面，则强制刷新（销毁并重建组件）
    editableTabsValue (newTabName, oldTabName) {
      if (!newTabName) return
      if (newTabName === oldTabName) return
      // 关闭/切换 Tab 时，等 DOM & tabs 状态稳定后再尝试刷新标记
      this.$nextTick(() => this.forceReloadIfNeeded(newTabName))
    }
  },
  mounted () {
    let _self = this;
    this.loadSystemMenu();
    if (document.documentElement.clientWidth <= 1370) {
      this.isCollaped = true;
      this.menuWidth = "63px";
      this.openMenuIcon = 'el-icon-s-unfold';
    }
    window.onresize = () => {
      return (() => {
        _self.leftmenuHeight = document.documentElement.clientHeight - _self.headerHeight;
        _self.clientHeight = document.documentElement.clientHeight;
      })()
    }
  },
  methods: {
    handleTabClick () {
      // 点击切换时也触发一次（有些场景 editableTabsValue 可能是程序设置）
      this.forceReloadIfNeeded(this.editableTabsValue)
    },
    forceReloadIfNeeded (tabName) {
      try {
        if (!tabName) return
        // `_tabReloadToken` 已在 data() 声明；这里不要运行时再往实例上“新增响应式属性”
        if (!this._tabReloadToken || typeof this._tabReloadToken !== 'object') {
          this._tabReloadToken = {}
        }
        if (!Array.isArray(this.editableTabs) || this.editableTabs.length === 0) return

        // 关闭 Tab 的瞬态过程中，索引可能变化；用 name 二次定位，避免对 undefined $set
        const idx = this.editableTabs.findIndex(t => t && t.name === tabName)
        if (idx < 0) return
        const tab = this.editableTabs[idx]
        const url = (tab && typeof tab.url === 'string') ? tab.url : ''
        // 只对“原始记录管理”页面生效（按路径匹配，不依赖 title）
        if (!url || url.indexOf('views/business/OriginalManagement/index.vue') === -1) return

        const token = Date.now().toString()
        // 记录最新 token，用于子页面检测“需要刷新”
        this.$set(this._tabReloadToken, String(tabName), token)

        const newUrl = this.appendReloadParam(url, token)
        if (newUrl && newUrl !== url) {
          // 再次确认 tab 仍存在且仍是同一个 name
          const idx2 = this.editableTabs.findIndex(t => t && t.name === tabName)
          if (idx2 < 0) return
          const current = this.editableTabs[idx2]
          if (!current || typeof current !== 'object') return
          this.$set(current, 'url', newUrl)
        }
      } catch (e) {
        // 防止关闭 Tab/切换时的瞬态状态导致 watcher 报错
        // 这里吞掉异常仅用于保证主框架稳定
        console.warn('[Main] forceReloadIfNeeded skipped due to error:', e)
      }
    },
    appendReloadParam (url, token) {
      if (!url) return url
      // 去掉旧的 __reload，保证 url 不会无限变长
      const cleaned = url.replace(/([?&])__reload=\d+(&?)/g, (m, p1, p2) => (p1 === '?' ? (p2 ? '?' : '') : (p2 ? p1 : '')))
        .replace(/[?&]$/, '')
      const joinChar = cleaned.indexOf('?') >= 0 ? '&' : '?'
      return `${cleaned}${joinChar}__reload=${token}`
    },
    updatepwd () {
      this.drawer = true;
      this.$nextTick(() => {
        if (this.$refs['updateUserPasswordWindow']) {
          this.$refs['updateUserPasswordWindow'].resertForm();
        }
      })
    },
    closeWindow (msg) {
      if (msg) {
        appjs.showSuccessMsg(msg, 2000, 50);
      }
      this.drawer = false;
    },
    addTab (targetName, modeleVue) {
      var url = modeleVue;
      var cleanModuleVue = modeleVue;

      // 处理带查询参数的URL
      if (modeleVue.indexOf("?") != -1) {
        cleanModuleVue = modeleVue.substring(0, modeleVue.indexOf("?"));
      }

      let tabName = "";
      let existingTabIndex = -1;
      this.editableTabs.forEach((item, index) => {
        if (item.title == targetName) {
          tabName = item.name;
          existingTabIndex = index;
        }
      })
      if (tabName != "") {
        // 如果标签页已存在，更新 url 以触发组件重新加载数据
        if (existingTabIndex >= 0) {
          const existingTab = this.editableTabs[existingTabIndex];
          // 针对“原始记录管理”页面：无论是否同一 url，每次进入都强制刷新
          if (cleanModuleVue.includes('views/business/OriginalManagement/index.vue')) {
            url = this.appendReloadParam(url, Date.now().toString())
          }
          if (existingTab.url !== url) {
            // 使用 Vue.set 确保响应式更新
            this.$set(this.editableTabs[existingTabIndex], 'url', url);
          }
        }
        this.editableTabsValue = tabName;
        return;
      }

      let newTabName = ++this.tabIndex + ''

      // 动态导入组件，使用清理后的路径
      let componentLoader;

      // 特殊处理原始记录组件
      if (cleanModuleVue.includes('RecordDialog.vue')) {
        componentLoader = () => import('@/views/business/OriginalManagement/RecordDialog.vue');
      } else if (cleanModuleVue.includes('RecordDialog3.vue')) {
        componentLoader = () => import('@/views/business/OriginalManagement/RecordDialog3.vue');
      } else {
        // 其他组件使用原来的动态导入方式
        componentLoader = () => import('@/' + cleanModuleVue);
      }

      this.editableTabs.push({
        title: targetName,
        name: newTabName,
        closable: true,
        url: url,
        content: componentLoader
      })
      this.editableTabsValue = newTabName
    },
    removeTab (targetName) {
      const tabs = this.editableTabs || []
      let activeName = this.editableTabsValue

      // 先基于“当前 tabs”计算要切到哪个 tab
      if (activeName === targetName) {
        const idx = tabs.findIndex(t => t && t.name === targetName)
        const nextTab = idx >= 0 ? (tabs[idx + 1] || tabs[idx - 1]) : null
        activeName = nextTab && nextTab.name ? nextTab.name : ''
      }

      // 先移除，再设置 active，避免 watcher 在“即将被移除的 tabName”上运行
      const newTabs = tabs.filter(tab => tab && tab.name !== targetName)
      this.editableTabs = newTabs

      if (!activeName) {
        activeName = (newTabs[0] && newTabs[0].name) ? newTabs[0].name : '1'
      }
      this.editableTabsValue = activeName
    },
    openCloseMenu () {
      this.isCollaped = !this.isCollaped;
      if (this.isCollaped) {
        this.openMenuIcon = 'el-icon-s-unfold';
        this.menuWidth = '63px';
      } else {
        this.openMenuIcon = 'el-icon-s-fold';
        this.menuWidth = '230px';
        this.activiArr.push('');
      }
    },
    meunChange (menu) {
      if (menu == "system") {
        this.menuData = this.systemData;
        this.systemWordColor = '#D7B920';
        this.bussinessWordColor = '#fff';
      } else {
        this.menuData = this.bussinessData;
        this.systemWordColor = '#fff';
        this.bussinessWordColor = '#D7B920';
      }
      this.activiArr = [];
      this.menuData.forEach((arr) => {
        this.activiArr.push(arr.moduleName);
      })
    },
    loadSystemMenu () {
      let _self = this;
      let load = appjs.loading("系统初始化中...")
      appjs.httpRequest('user/getMenuData', { pageType: 'p' }).then((data) => {
        if (data.retCode && data.retCode != 'ok') {
          appjs.showErrorMsg(data.retMsg);
          appjs.unloading(load);
        } else {
          if (data.bussinessData.length > 0) {
            _self.menuData = data.bussinessData;
            this.systemWordColor = '#fff';
            this.bussinessWordColor = '#D7B920';
          } else if (data.systemData.length > 0) {
            _self.menuData = data.systemData;
            this.systemWordColor = '#D7B920';
            this.bussinessWordColor = '#fff';
          }
          _self.systemData = data.systemData;
          _self.bussinessData = data.bussinessData;
          console.log("system" + data.systemData)
          console.log("bussin" + data.bussinessData)
          _self.menuData.forEach((arr) => {
            _self.activiArr.push(arr.moduleName);
          })
          if (_self.systemData.length > 0 && _self.bussinessData.length > 0) {
            _self.systemButVisible = true;
            _self.bussinessButVisible = true;
          }
          appjs.unloading(load);
        }
      }).catch((error) => {
        appjs.showErrorMsg("服务器异常：" + error)
        appjs.unloading(load);
      })
    },
    showMyDialog () {
      this.isShowContextMenu = true;
    },
    closeMyDialog () {
      let self = this;
      setTimeout(function () {
        if (self.isMouseInMenu == false) {
          self.isShowContextMenu = false;
        }
      }, 500);
    },
    handleMouseOver () {
      this.isMouseInMenu = true;
    },
    handleMouseLeave () {
      this.isMouseInMenu = false;
      this.isShowContextMenu = false;
    },
    exit () {
      window.localStorage.clear();
      this.$router.push("/login");
    }

  }
}
</script>
<style>
div.contextMenu {
  /* display: block; */
  position: absolute;
  z-index: 9999;
  top: calc(100% + 1px);
  right: 3px;
  width: 200px;
  font-size: 14px;
  background: #fff;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgb(150, 150, 150);
  border: 1px solid rgba(150, 150, 150, 0.95);
  padding: 4px 0;
  box-shadow: 0 2px 2px rgba(100, 100, 100, 0.9);
  border-radius: 5px;
  border-radius: 5px;
  color: #000;
}
div.contextMenu ul {
  margin: 0;
  padding: 0;
}
div.contextMenu li {
  list-style: none;
  padding: 5px 10px;
}
div.contextMenu li:hover {
  background: #0066ff;
  color: white;
}
</style>
